import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-input-label-list',
  templateUrl: './input-label-list.component.html',
  styleUrls: ['./input-label-list.component.scss'],
})
export class InputLabelListComponent {
  @Input() items: { id: string; label: string; value: string }[] = [];
  @Output() changeEvent: EventEmitter<{ id: string; value: string }[]> = new EventEmitter();

  constructor() {}

  trackByFn(_: number, index: number) {
    return index;
  }
}
